import { logDebug } from "../../tracing";

const initLibs = () => {
    // https://support.google.com/analytics/answer/7201382?hl=en

    return new Promise((resolve, reject) => {
        if (window.gtag && window.fbq) {
            logDebug('window.gtag && window.fbq ALL INITIALIZED!');
            return resolve({
                gtag: window.gtag,
                fbq: window.fbq
            });
        }
        let retryCount = 4;
        const interval = setInterval(function () {
            try {
                logDebug('--> Run analytics script');

                if (window.gtag && window.fbq) {
                    logDebug('--> ga gtag and fbq ALL DEFINED');

                    clearInterval(interval);
                    return resolve({
                        gtag: window.gtag,
                        fbq: window.fbq
                    });
                }
                if (retryCount === 0) {
                    clearInterval(interval);
                    return reject('Some function is not defined');
                }

                retryCount = retryCount - 1;
            } catch (error) {
                reject(error);
            }
        }, 1000);
    });
};

export default {initLibs}